import styled from 'styled-components';
import DefaultButton from 'components/Buttons/Button';
import DefaultMenu from '@material-ui/core/Menu';
import DefaultMenuItem from '@material-ui/core/MenuItem';

// TODO: TFR-45:Button make unique name or do not export
export const Button = styled(DefaultButton)`
  margin-left: 1rem;
`;

export const Menu = styled(DefaultMenu)``;
export const MenuItem = styled(DefaultMenuItem)``;
